export const FUNNEL_PLATFORMS = ['wootalk', 'ut', 'ek21', 'site', 'jd'] as const;

export type FunnelPlatform = (typeof FUNNEL_PLATFORMS)[number];

export type FunnelCounts = {
  platform: FunnelPlatform;
  link_sent: number;
  click: number;
  signup: number;
};

function isPlatform(value: string): value is FunnelPlatform {
  return (FUNNEL_PLATFORMS as readonly string[]).includes(value);
}

function countOf(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.trunc(n);
}

export function fillFunnel(rows: unknown): FunnelCounts[] {
  const parsed = new Map<FunnelPlatform, FunnelCounts>();
  if (Array.isArray(rows)) {
    for (const row of rows) {
      if (typeof row !== 'object' || row === null) continue;
      const rec = row as Record<string, unknown>;
      const platform = typeof rec.platform === 'string' ? rec.platform : '';
      if (!isPlatform(platform)) continue;
      parsed.set(platform, {
        platform,
        link_sent: countOf(rec.link_sent),
        click: countOf(rec.click),
        signup: countOf(rec.signup),
      });
    }
  }
  return FUNNEL_PLATFORMS.map(
    (platform) => parsed.get(platform) ?? { platform, link_sent: 0, click: 0, signup: 0 },
  );
}
